'use strict';

module.exports = function (ngModule) {
    require('./renderhtml')(ngModule);
}



/** WEBPACK FOOTER **
 ** ./src/changelog/directives/index.js
 **/